import 'rc-slider/assets/index.css';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import ConstCommon from '../../common/Const';
import Tab from '../../common/tab-timer';
import Footer from '../../common/table/Footer';
import { getQueryParams } from '../../helpers/Common';
import Export from './export/export';
import ScrollComponent from './../../common/ScrollComponent';
import Button from './Button';
import Filter from './filter/Filter';
import ScreenerParameter from './filter/ScreenerParameter';
import Financial from './financial/Financial';
import './screener.scss';
import { MyScreener, TopScreener } from './my-screener';
import Performance from './performance/Performance';
import {
  getScreenerData,
  getTopScreeners,
  getUserScreeners,
  REDUCER_NAME,
  saveScreener,
  subscribeRealtimeTick,
  fetchIndustryData,
  changeRange,
  changeSortState,
  changeScreener,
} from './reducer';
import Result from './result/Result';
import { Popup, Response, Save } from './save';
import Technical from './technical/Technical';
import Const from './Const';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';

class Screener extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 1,
    };
  }

  componentDidMount() {
    const { getScreenerData, fetchIndustryData } = this.props;
    const screenerIdFromQuery = getQueryParams('screenerId');
    if (!screenerIdFromQuery) {
      getScreenerData();
    }
    fetchIndustryData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentDidUpdate(prevProps) {
    const {
      getScreenerData,
      fetchIndustryData,
      topScreener,
      userScreener,
    } = this.props;
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      getScreenerData();
      fetchIndustryData();
      getTopScreeners();
    }
    const screenerFromQuery = getQueryParams('screenerId');
    const isChangeTopScreener = !prevProps.topScreener && topScreener;
    if (screenerFromQuery && isChangeTopScreener && userScreener) {
      this.changeScreenerFromQuery();
    }
  }

  componentWillUnmount() {
    const { changeRange } = this.props;
    changeRange([]);
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  changeScreenerFromQuery = () => {
    const screenerId = getQueryParams('screenerId');
    const {
      topScreener,
      userScreener,
      changeScreener,
      getScreenerData,
    } = this.props;
    const isTopScreener = topScreener.some(
      item => item.screenerId === +screenerId,
    );
    if (isTopScreener) {
      changeScreener(+screenerId, true);
      return;
    }
    const isUserScreener = userScreener.some(
      item => item.screenerId === +screenerId,
    );
    if (isUserScreener) {
      changeScreener(+screenerId, false);
      return;
    }
    getScreenerData();
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTick } = this.props;
    subscribeRealtimeTick(data);
  };

  changeTab = currentTab => {
    this.setState({ currentTab });
  };

  getNewSortState = () => {
    const { sortState, parameters } = this.props;
    if (!Object.keys(sortState).length) {
      return {};
    }
    const currentSortCode = Object.keys(sortState)[0].split('.')[1];
    const isExist = parameters.some(
      param => param.code.toLowerCase() === currentSortCode.toLowerCase(),
    );

    return isExist ? sortState : {};
  };

  applyFilter = () => {
    const { changeSortState } = this.props;
    changeSortState(this.getNewSortState());
  };

  render() {
    const { totalRecords = 0, selectScreener = {}, id } = this.props;
    const stringSettings = selectScreener.settings;
    let comGroupCode = Const.defaultWatchList;
    let icbCode = Const.defaultIcbCode;
    let parameters = [];
    let settings = {};
    if (stringSettings) {
      settings = JSON.parse(stringSettings);
      comGroupCode = settings.comGroupCode;
      icbCode = settings.icbCode;
      parameters = settings.parameters;
    }

    return (
      <PreRender {...this.props}>
        <Provider value={id}>
          <ComponentNameProvider value={ConstCommon.listComponent.Screener}>
            <ScrollComponent>
              <div className="screener-wrapper d-flex flex-fill flex-column h-100">
                <Popup
                  placeholder={I18n.t(
                    'stockScreener.screenerMessage.placeHolder',
                  )}
                  titleYes={I18n.t('stockScreener.button.CREATE')}
                />
                <Response />
                <div className="top-nav px-20 pt-8 d-flex flex-fill flex-column h-auto">
                  <div className="d-flex jus-spa">
                    <Filter comGroupCode={comGroupCode} icbCode={icbCode} />
                    <div className="mt-8 float-right d-inline-flex">
                      <span className="mr-5">
                        <TopScreener />
                      </span>
                    </div>
                  </div>

                  <div className="criteria-content">
                    <ScreenerParameter parameters={parameters} />
                    <div className="criteria-button">
                      <div className="mt-10 float-right">
                        <span className="mr-5">
                          <Button
                            buttonName={I18n.t('stockScreener.button.APPLY')}
                            onClick={this.applyFilter}
                          />
                        </span>
                        <Save />
                      </div>
                    </div>
                  </div>
                  <div className="criteria-result d-flex flex-fill flex-column">
                    <div className="result-total mb-10">
                      {` ${I18n.t(
                        'stockScreener.button.result',
                      )} (${totalRecords}) `}
                    </div>
                    <div className="d-flex justify-content-between">
                      <Tab
                        currentTab={this.state.currentTab}
                        listTab="stockScreener.tab"
                        changeTab={this.changeTab}
                      />
                      <div className="text-right">
                        {<Export {...this.props} tab={this.state.currentTab} />}
                      </div>
                    </div>

                    <div className="clearfix" />
                    <div className="result-table top-mover-content d-flex flex-fill flex-column">
                      {this.state.currentTab === 1 && <Result />}
                      {this.state.currentTab === 2 && <Performance />}
                      {this.state.currentTab === 3 && <Financial />}
                      {this.state.currentTab === 4 && <Technical />}
                    </div>
                    <div className="d-flex">
                      <Footer />
                      <div className="powered-by-fiinTrade ml-auto">
                        {I18n.t('common.poweredByFiinTrade')}
                        <a href="https://fiintrade.vn" target="_blank">
                          FiinTrade
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollComponent>
          </ComponentNameProvider>
        </Provider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    totalRecords: state[REDUCER_NAME].totalRecords,
    userScreener: state[REDUCER_NAME].userScreener,
    topScreener: state[REDUCER_NAME].topScreener,
    selectScreener: state[REDUCER_NAME].selectScreener,
    listIndustry: state[REDUCER_NAME].listIndustry,
    locale: state.i18n.locale,
    sortState: state[REDUCER_NAME].sortState,
    parameters: state[REDUCER_NAME].parameters,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getScreenerData: () => dispatch(getScreenerData()),
    fetchIndustryData: () => dispatch(fetchIndustryData()),
    getUserScreeners: () => dispatch(getUserScreeners()),
    getTopScreeners: () => dispatch(getTopScreeners()),
    saveScreener: name => dispatch(saveScreener(name)),
    changeRange: param => dispatch(changeRange(param)),
    subscribeRealtimeTick: data => dispatch(subscribeRealtimeTick(data)),
    changeSortState: sortState => dispatch(changeSortState(sortState)),
    changeScreener: (...args) => dispatch(changeScreener(...args)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Screener);
